import { CHECK_FILE, CREATE_FIVES_FOURS, CHECK_FOURS, CREATE_FOURS, CHECK_FIVE, CREATE_FIVE, CHECKER_SET_LOADING, CHECKER_ERROR } from '../actions/types'

const initialState = {
  summary: null,
  check_fours: {},
  check_fives: {},
  created_fours: "",
  created_five: "",
  loading: true,
  error: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CHECKER_SET_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };
    case CHECKER_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case CHECK_FILE:
      return {
        ...state,
        summary: action.payload,
        loading: false
      }
    case CREATE_FIVES_FOURS:
      return {
        ...state,
        summary: action.payload,
        loading: false
      }
    ///////////////////////////////////
    case CHECK_FOURS:
      return {
        ...state,
        check_fours: action.payload,
        loading: false
      };
      case CREATE_FOURS:
      return {
        ...state,
        created_fours: action.payload,
        check_fours:{
          text: action.payload,
          brak: false
        },
        loading: false
      };
    case CHECK_FIVE:
      return {
        ...state,
        check_fives: action.payload,
        loading: false
      };
    case CREATE_FIVE:
      return {
        ...state,
        created_fives: action.payload,
        check_fives:{
          text: action.payload,
          brak: false
        },
        loading: false
      };
    default:
      return state
  }
}